import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Text, CheckIcon } from '@beef/ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const ColorCircle = ({ color }) => (
  <span className={cx('color')} style={{ background: color }} />
);

ColorCircle.propTypes = {
  color: PropTypes.string,
};

class FiltersOption extends Component {
  handleChange = (e) => {
    const { onChange } = this.props;
    onChange();
    e.preventDefault();
  };

  render() {
    const { notShowOptionsCounters, name, count, color, isChecked, isDisabled, className } =
      this.props;
    return count ?
        <div
          className={cx('component', { disabled: isDisabled }, className)}
          onClick={isDisabled ? null : this.handleChange}
        >
          <span className={cx('checkbox', isChecked && 'checked', isDisabled && 'disabled')}>
            <CheckIcon size="xs" fill="#fff" className={cx('icon')} />
          </span>
          <span className={cx('content')}>
            {color && <ColorCircle color={color} />}
            <Text size="size6-r">{name}</Text>
          </span>
          {!notShowOptionsCounters && <div className={cx('count')}>{count}</div>}
        </div>
      : null;
  }
}

FiltersOption.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  count: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
  notShowOptionsCounters: PropTypes.bool,
};

export default FiltersOption;
